<template>
  <div>
    <button
      ref="open_button"
      tabindex="0"
      role="button"
      class="btn m-1"
      @click="toggle_menu"
    >
      <i class="fa-solid fa-ellipsis-vertical"></i>
    </button>
    <teleport to="#app">
      <ul
        v-if="open"
        ref="dropdown_content"
        tabindex="-1"
        class="menu bg-base-100 rounded-box fixed z-10 max-h-screen w-52 overflow-auto p-2 shadow-sm"
      >
        <li
          v-if="file_or_folder.toLowerCase() === 'file'"
          @click="handle_click('download')"
        >
          <a>
            <i class="fa-solid fa-download"></i> Tải
            {{ localized_item_type }}
          </a>
        </li>
        <li @click="handle_click('delete')">
          <a>
            <i class="fa-solid fa-trash-can"></i> Xóa
            {{ localized_item_type }}
          </a>
        </li>
        <li @click="handle_click('rename')">
          <a>
            <i class="fa-solid fa-pen"></i> Đổi tên
            {{ localized_item_type }}
          </a>
        </li>
        <li
          v-if="file_or_folder.toLowerCase() === 'file'"
          @click="handle_click('execute')"
        >
          <a>
            <i class="fa-solid fa-person-running"></i> Thực thi
            {{ localized_item_type }}
          </a>
        </li>
      </ul>
    </teleport>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { computed, nextTick, onMounted, ref } from "vue";
import type { file_action } from ".";

const props = withDefaults(
  defineProps<{
    file_or_folder?: string;
  }>(),
  {
    file_or_folder: "file",
  },
);
const open = ref(false);
const open_button = ref<HTMLButtonElement | null>();
const dropdown_content = ref<HTMLUListElement | null>();
const localized_item_type = computed(() => {
  return props.file_or_folder === "file" ? "tệp tin" : "thư mục";
});

const toggle_menu = () => {
  if (open.value) {
    open.value = false;
    return;
  }

  open_menu();
};

const open_menu = () => {
  open.value = true;
  // wait for content to be viable so that we can calculate the height of it
  nextTick(calulate_pos);
};

const calulate_pos = () => {
  const bounding_client_rect = open_button.value?.getBoundingClientRect();
  if (!bounding_client_rect) {
    console.log("no bouding_client");
    return;
  }
  if (!dropdown_content.value) {
    console.log("no menu");
    return;
  }
  if (!open_button.value) {
    return;
  }

  const menu_height = dropdown_content.value.clientHeight ?? 82;
  const pos_under_button =
    bounding_client_rect.top + 8 + open_button.value.offsetHeight;
  const is_overflow = (): boolean => {
    return pos_under_button + menu_height > document.body.offsetHeight;
  };
  dropdown_content.value.style.top = is_overflow()
    ? bounding_client_rect.top - 8 - menu_height + "px"
    : (dropdown_content.value.style.top = pos_under_button + "px");
  dropdown_content.value.style.left = bounding_client_rect.left - 156 + "px";
};

onClickOutside(dropdown_content, () => {
  open.value = false;
});

onMounted(() => {
  document.addEventListener("wheel", () => {
    open.value = false;
  });
  return document.removeEventListener("wheel", () => {});
});

const emit = defineEmits(["download", "delete", "rename", "execute"]);
const handle_click = (emit_string: file_action) => {
  (document.activeElement as HTMLElement).blur();
  open.value = false;
  emit(emit_string);
};
</script>
